import styled from 'styled-components';
import { Text } from '../text/text.component.js';

const Wrapper = styled.div `
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${props => props.padding};
`;
const Line = styled.hr.attrs({
    'aria-hidden': true,
}) `
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.colors.background.tertiary};
  border: none;
`;
const StyledText = styled(Text) `
  width: fit-content;
  text-align: center;
  display: inline;
  padding: 0 8px;
`;

export { Line, StyledText, Wrapper };
